import format from 'date-fns/format';
import nl from 'date-fns/locale/nl';

const shape = 'yyyy-MM-dd';

const parseToDateString = (date: Date | number) => format(date, shape, { locale: nl });

export default parseToDateString;
